import type { SVGProps } from 'react';
const SvgCopyDetalized = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.45}
      d="M13.715 0H4.143a.143.143 0 0 0-.142.143v1c0 .078.064.143.142.143h8.858V13.57c0 .079.064.143.142.143h1a.143.143 0 0 0 .143-.143v-13A.57.57 0 0 0 13.715 0m-2.286 2.286H2.286a.57.57 0 0 0-.571.571v9.477c0 .152.06.296.168.404l3.094 3.094q.06.06.132.098v.034h.075a.6.6 0 0 0 .197.036h6.048a.57.57 0 0 0 .572-.571V2.857a.57.57 0 0 0-.572-.571m-6.321 11.86L3.57 12.607h1.538zm5.607.568H6.25V12.18a.714.714 0 0 0-.715-.715H3.001V3.571h7.714z"
    />
    <path
      stroke="currentColor"
      strokeOpacity={0.45}
      strokeWidth={0.001}
      d="M11.429 2.286a.57.57 0 0 1 .571.571V15.43a.57.57 0 0 1-.571.57H5.38a.6.6 0 0 1-.196-.035H5.11v-.034a1 1 0 0 1-.07-.044l-.062-.054-3.095-3.095a.6.6 0 0 1-.071-.087q-.013-.021-.024-.044a.57.57 0 0 1-.072-.272V2.857a.57.57 0 0 1 .57-.57zM3 11.464h2.536a.714.714 0 0 1 .714.715v2.535h4.465V3.57H3zM4.144 0h9.57a.57.57 0 0 1 .572.57v13a.14.14 0 0 1-.088.131.14.14 0 0 1-.054.012h-1A.14.14 0 0 1 13 13.57V1.285H4.144A.143.143 0 0 1 4 1.143v-1c0-.079.064-.142.143-.142ZM3.57 12.606v.001l1.537 1.54v-.002h.001v-1.538z"
    />
  </svg>
);
export default SvgCopyDetalized;
